import { sharedWeeklySource } from "../lib/rounds";
import { createNextCandleLoop, resolveNextCandle } from "./predictNextCandleStores";

/**
 * The Predict weekly Next-Candle Loop (ADR-0006; spec §7): 40 weekly Context
 * candles, guess the next candle green/red, reveal it. Its own persisted
 * score/Streak, separate from the daily Loop's.
 *
 * Since ADR-0013 the weekly bank is a barrier bank like every other, so the
 * answer is the Round's first Forward candle and the adapter is the shared
 * one; only the bank and the persistence keys are weekly here.
 */

/** Resolve a weekly commitment: the answer is the Round's first Forward candle. */
export const resolvePredictWeekly = resolveNextCandle;

export const usePredictWeeklyStore = createNextCandleLoop({
  timeframe: "weekly",
  openSource: sharedWeeklySource,
  seenKey: "seen:weekly",
  scoreKey: "weekly:score",
  streakKey: "weekly:streak",
});
